import ProgressIndicator from 'components/common/progress-indicator';
import { ReactNode } from 'react';

type LevelImageSectionProps = Readonly<{
  label: string;
  indicatorChecked: boolean;
  children: ReactNode;
}>;

export default function LevelImageSection({
  label,
  indicatorChecked,
  children
}: LevelImageSectionProps) {
  return (
    <div className='shrink-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm'>
      <div className='flex w-full items-center gap-2 px-4 py-3'>
        <span className='flex items-center gap-2 font-medium text-gray-800'>
          <ProgressIndicator checked={indicatorChecked} />
          {label}
        </span>
      </div>
      <div className='border-t border-gray-200 p-3'>{children}</div>
    </div>
  );
}
